"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.SpinnerContainer=void 0;const SpinnerContainer=exports.SpinnerContainer=_styledComponents.default.div`
 width: 100vw;
 height:100vh;
 display:flex;
 justify-content:center;
 align-items: center;
 background-color: #00000070;
 position: absolute
`;